import React, { useEffect, useState, useRef, useContext } from "react";
import "../css/profileSetup.css";
import googleMeet from "../img/goolgeMeet.png";
import axiosHttp from "../config/axios.interceptor";
import {
  base_url,
  errorResponseMessage,
  googleClientId,
  httpHeaderConfig,
} from "../shared/const.prop";
import { AppContext } from "../contexts/AppContext";
import { AuthContext } from "../contexts/AuthContext";
import { UserProfileContext } from "../contexts/UserProfileStepsContext";
import Select from "react-select";
import Loader from "../components/Loader";
import Multiselect from "multiselect-react-dropdown";
import { useDispatch, useSelector } from "react-redux";
import { updateProfileImage } from "../store/actions/userActions";
import axios from "axios";
import undrawProfile from "../img/undraw_profile.svg";
import { useNavigate } from "react-router-dom";

const ProfileSetup = () => {
  const navigate = useNavigate();
  const userContext = useContext(UserProfileContext);
  const appContext = useContext(AppContext);
  const authContext = useContext(AuthContext);
  const dispatch = useDispatch();
  const storedStepFirst = JSON.parse(localStorage.getItem("stepFirst") || "{}");
  const storedStepSecond = JSON.parse(
    localStorage.getItem("stepSecond") || "{}"
  );
  const stepNo = localStorage.getItem("step");
  const [step, setStep] = useState(stepNo ? parseInt(stepNo) : 1);
  const [formData, setFormData] = useState({
    Name: storedStepFirst?.Name || "",
    headline: storedStepFirst?.headline || "",
    about: "",
    institute: "",
    degree: storedStepFirst?.education || "",
    company: "",
    designation: "",
    occupation: storedStepFirst?.occupation || "",
    yearsOfExperience: storedStepFirst?.yearsOfExperience || "",
    organization: "",
    // timezone: storedStepFirst?.timeZone || "66291756f5181c284d0dbbf0",
    timezone: storedStepFirst?.timeZone || "",
    timeZone: storedStepFirst?.timeZone || "",
    education: storedStepFirst?.education || "",
    skillsCategory: storedStepSecond?.skillsCategory || [],
    interest: storedStepSecond?.interest || [],
    skills: storedStepSecond?.skills || [],
    experties: storedStepSecond?.experties || [],
  });
  const [loading, setLoading] = useState(false);
  const [skills, setSkills] = useState([]);
  const [interest, setInterest] = useState([]);
  const [expertise, setExpertises] = useState([]);
  const [categories, setCategories] = useState([]);
  const [timeZoneList, setTimeZoneList] = useState([]);
  const [skillValue, setSkillValue] = useState("");
  const [interestValue, setInterestValue] = useState("");
  const [expertiseValue, setExpertiseValue] = useState("");
  const [servicesOffered, setServicesOffered] = useState(false);
  const [upskillingServices, setUpskillingServices] = useState(false);
  const [businessConsulting, setBusinessConsulting] = useState(false);
  const [isNextStepEnabled, setIsNextStepEnabled] = useState(false);
  const [profilePictureUrl, setProfilePictureUrl] = useState("");
  const [imageLoading, setImageLoading] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [googleData, setGoogleData] = useState({});
  const [about, setAbout] = useState("");
  const fileInputRef = useRef(null);
  const selectedValue = timeZoneList.find(
    (option) => option._id?.$oid === formData.timezone
  );

  useEffect(() => {
    if (step === 4) {
      validateGoogleAuthentication();
    }
  }, [step]);

  const fetchSkillsList = async () => {
    try {
      const getSkillsList = await axiosHttp.get(
        `skills-new?skill=${skillValue}`
      );
      setSkills(getSkillsList.data.data);
    } catch (error) {
      if (error.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
        authContext.logout();
      }
      if (error.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
      }
      if (error.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
      setSkills([]);
    }
  };

  const fetchInterestList = async () => {
    try {
      const getSkillsList = await axiosHttp.get(
        `skills-new?skill=${interestValue}`
      );
      setInterest(getSkillsList.data.data);
    } catch (error) {
      if (error.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
        authContext.logout();
      }
      if (error.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
      }
      if (error.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
      setSkills([]);
      console.log(error);
    }
  };

  const fetchExpertisesList = async () => {
    try {
      const getSkillsList = await axiosHttp.get(
        `skills-new?skill=${expertiseValue}`
      );
      setExpertises(getSkillsList.data.data);
    } catch (error) {
      if (error.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
        authContext.logout();
      }
      if (error.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
      }
      if (error.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
      setSkills([]);
      console.log(error);
    }
  };

  const fetchCategories = async () => {
    setLoading(true);
    try {
      const getCategoriesList = await axiosHttp.get(`skills-category`);
      setCategories(getCategoriesList.data);
      fetchTimeZone();
    } catch (error) {
      if (error.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
        authContext.logout();
      }
      if (error.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
      }
      if (error.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
      setCategories([]);
      fetchTimeZone();
    }
  };

  const fetchTimeZone = async () => {
    try {
      const getCategoriesList = await axiosHttp.get(`timezone`);
      if (getCategoriesList.status === 200) {
        setTimeZoneList(getCategoriesList.data.data);
        setLoading(false);
      }
    } catch (error) {
      if (error?.response?.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
        authContext.logout();
      }
      if (error?.response?.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
      }
      if (error.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
      setTimeZoneList([]);
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  useEffect(() => {
    if (skillValue !== "") {
      const getData = setTimeout(fetchSkillsList, 500);
      return () => clearTimeout(getData);
    }
  }, [skillValue]);

  useEffect(() => {
    if (interestValue !== "") {
      const getData = setTimeout(fetchInterestList, 500);
      return () => clearTimeout(getData);
    }
  }, [interestValue]);

  useEffect(() => {
    if (expertiseValue !== "") {
      const getData = setTimeout(fetchExpertisesList, 500);
      return () => clearTimeout(getData);
    }
  }, [expertiseValue]);

  // Handles input changes for Step 1 and Step 2 fields
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const hanldleTimezoneChange = (selectedOption) => {
    setFormData({ ...formData, timezone: selectedOption.value });
  };

  // Validates Step 1 inputs
  const validateStep1 = () => {
    return (
      formData.Name.trim() !== "" &&
      formData.headline.trim() !== "" &&
      formData.yearsOfExperience.trim() !== "" &&
      formData.timezone.trim() !== "" &&
      formData.education.trim() !== ""
    );
  };

  const validateOtherSteps = () => {
    // if (step === 2) {
    //   return formData.skillsCategory.length !== 0;
    // }
    if (step === 3) {
      return true; // Always enable the button for Step 3
    }
    if (step === 5) {
      return about !== ""; // Ensure a profile picture is uploaded
    }
    return true;
  };

  useEffect(() => {
    if (step === 1) {
      setIsNextStepEnabled(validateStep1());
    } else {
      setIsNextStepEnabled(validateOtherSteps());
    }
  }, [
    formData,
    step,
    servicesOffered,
    upskillingServices,
    businessConsulting,
    about,
  ]);

  // Handles navigation to the next step
  const handleNextStep = (e) => {
    e.preventDefault();
    if (isNextStepEnabled) {
      if (step < 5) {
        if (step === 1) {
          const firstPayload = {
            Name: formData.Name,
            timezone: formData.timezone,
            headline: formData.headline,
            occupation: formData.occupation,
            yearsOfExperience: formData.yearsOfExperience,
            education: formData.education,
          };
          localStorage.setItem("stepFirst", JSON.stringify(firstPayload));
        }

        if (step === 2) {
          let secondPayload = {
            interest: formData.interest,
            skills: formData.skills,
            experties: formData.experties,
            skillsCategory: formData.skillsCategory,
          };
          localStorage.setItem("stepSecond", JSON.stringify(secondPayload));
        }
        setStep(step + 1);
        localStorage.setItem("step", step + 1);
      } else if (step === 5) {
        profileSubmitHandler();
      }
    }
  };

  const profileSubmitHandler = async () => {
    const localData = JSON.parse(localStorage.getItem("registerConfirm"));
    const code = localData.verification_code;
    const userId = localData.user_id;
    let submitPayload = {
      code,
      userId,
      firstName: formData.Name,
      lastName: "",
      dob: "",
      gender: "",
      countryCode: "",
      phoneNumber: "",
      whatsappNumber: "",
      link: "",
      about: about,
      experiences: formData.headline,
      timezone: formData.timezone,
      address: {
        country: "",
        state: "",
        city: "",
      },
      offerService: false,
      languages: [],
      education: [
        {
          name: "",
          type: "",
          className: formData.education,
          startYear: "",
          endYear: "",
        },
      ],
      experience: [
        {
          companyName: "",
          position: formData.occupation,
          experience: formData.yearsOfExperience,
        },
      ],
      skills: formData.skills,
      interest: formData.interest,
      experties: formData.experties,
      skillsCategory: formData.skillsCategory,
    };
    try {
      const submittedData = await axiosHttp.post(
        `profile-setup`,
        submitPayload
      );
      appContext.updateLoaderState(false);
      if (submittedData.status === 201) {
        localStorage.removeItem("userId");
        localStorage.removeItem("step");
        localStorage.removeItem("stepFirst");
        localStorage.removeItem("stepSecond");
        localStorage.removeItem("registerConfirm");
        appContext.updateNotificationState({
          show: true,
          type: "success",
          message: "You Profile setup has been done successfully",
        });
        // setTimeout(() => {
        navigate("../login", { replace: true, relative: "path" });
        // }, 4000);
      }
    } catch (e) {
      //console.log(e);
      if (e.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
        authContext.logout();
      }
      if (e.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
      }
      appContext.updateLoaderState(false);
      if (e.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
        return;
      }
      appContext.updateNotificationState({
        show: true,
        type: "error",
        message: errorResponseMessage(e),
      });
    }
  };

  // Handles profile picture change for Step 5
  const handleProfilePictureChange = (e) => {
    const file = e.target.files && e.target.files[0];
    if (file) {
      profileImageHandler(file);
    } else {
      console.error("No file selected or an issue with the file input.");
      appContext.updateNotificationState({
        show: true,
        type: "error",
        message: "No file selected or an issue with the file input.",
      });
    }
  };

  const profileImageHandler = async (file) => {
    setImageLoading(true);

    const formData = new FormData();
    formData.append("image", file);

    try {
      const imageResponse = await axios.post(
        base_url + "upload-image",
        formData,
        {
          headers: {
            ...httpHeaderConfig,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      console.log("resp", imageResponse);
      if (imageResponse.status === 200) {
        updateProfilePic(imageResponse?.data?.tempPath, file);
      }
    } catch (error) {
      if (error.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
      setImageLoading(false);
    }
  };

  const updateProfilePic = async (path, file) => {
    const localData = JSON.parse(localStorage.getItem("registerConfirm"));
    const code = localData.verification_code;
    const userId = localData.user_id;
    try {
      const updateProfile = await axiosHttp.post("register-profile-picture", {
        userId,
        code,
        url: path,
      });
      if ((updateProfile.status = 201)) {
        setProfilePictureUrl(URL.createObjectURL(file));
        setImageLoading(false);
      }
    } catch (error) {
      if (error.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
    }
  };

  const handleLinkAccount = () => {
    const localData = JSON.parse(localStorage.getItem("registerConfirm"));
    const userId = localData.user_id;
    const state = {
      user_id: userId,
      screen: "profile",
    };
    const scope =
      "https://www.googleapis.com/auth/calendar https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile openid";
    const redirectUri = "https://upskillmeet.com/api/v1/auth/google/callback";
    const authUrl =
      `https://accounts.google.com/o/oauth2/auth?` +
      `client_id=${googleClientId}&redirect_uri=${redirectUri}&scope=${scope}&state=${JSON.stringify(
        state
      )}&response_type=code&access_type=offline&prompt=consent&value=profile`;
    window.location.href = authUrl;
    validateGoogleAuthentication();
  };

  const validateGoogleAuthentication = async () => {
    const localData = JSON.parse(localStorage.getItem("registerConfirm"));
    const userId = localData.user_id;
    const code = localData.verification_code;
    try {
      const getGoogleDetails = await axiosHttp.post("register-auth/google", {
        userId,
        code,
      });
      if (getGoogleDetails.status === 200) {
        if (getGoogleDetails.data.data.google_gmail === null) {
          setGoogleData({});
          setIsAuthenticated(false);
        } else {
          setGoogleData(getGoogleDetails.data.data);
          setIsAuthenticated(true);
        }
      }
    } catch (error) {
      if (error.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
    }
  };

  return loading ? (
    <Loader />
  ) : (
    <div className="profile-setup-container">
      <div className="message">
        {step === 1 && (
          <>
            <h2>Welcome to Upskillmeet!</h2>
            <p className="sub-title">
              We just need some basic info to get your profile setup. You’ll be
              able to edit this later.
            </p>
          </>
        )}

        {step === 2 && (
          <>
            <h2>Let’s get to know your skills and interests!</h2>
            <p className="sub-title">
              Filling out this information will help us match you with the right
              opportunities and users.
            </p>
          </>
        )}

        {step === 3 && (
          <>
            <h2>Define your services</h2>
            <p className="sub-title">
              Let us know what kind of services you want to offer.This feature
              is available for premium users only. To unlock all premium
              features, please visit the subscription page and upgrade your
              plan.
            </p>
          </>
        )}

        {step === 4 && (
          <>
            <h2>Connect your video app</h2>
            <p className="sub-title">
              Connect your video app to use them on your one on one sessions.
            </p>
          </>
        )}

        {step === 5 && (
          <>
            <h2>Nearly there!</h2>
            <p className="sub-title">
              A brief description and a profile photo will help people recognize
              you. Complete your profile to start booking sessions!
            </p>
          </>
        )}
      </div>
      <div className="profile-setup-form-content">
        <form className="profile-setup-form" onSubmit={handleNextStep}>
          <div className="step-indicator">
            <span>Step {step}/5</span>
            <div className="progress-bar-container">
              {/* Map through each step and display the bar part */}
              {Array.from({ length: 5 }).map((_, index) => (
                <div
                  key={index}
                  className={`progress-bar-part ${
                    index < step ? "active" : ""
                  }`}
                  onClick={() => setStep(index + 1)}
                ></div>
              ))}
            </div>
          </div>

          {/* Step 1: Personal Information */}
          {step === 1 && (
            <div className="form-grid">
              <div className="form-group">
                <label htmlFor="Name">
                  Full name <span className="red">*</span>
                </label>
                <input
                  type="text"
                  id="Name"
                  name="Name"
                  placeholder="e.g., John Doe"
                  value={formData.Name}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="headline">
                  Headline<span className="red">*</span>
                </label>
                <input
                  type="text"
                  id="headline"
                  name="headline"
                  placeholder="e.g., Software Engineer"
                  value={formData.headline}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="yearsOfExperience">
                  Years of Experience<span className="red">*</span>
                </label>
                <input
                  type="number"
                  id="yearsOfExperience"
                  name="yearsOfExperience"
                  placeholder="5"
                  value={formData.yearsOfExperience}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="occupation">
                  Occupation<span className="red">*</span>
                </label>
                <input
                  type="text"
                  id="occupation"
                  name="occupation"
                  placeholder="Software engineer"
                  value={formData.occupation}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="timezone">
                  Timezone<span className="red">*</span>
                </label>

                <Select
                  options={timeZoneList.map(({ _id, text }) => ({
                    value: _id?.$oid,
                    label: text || "",
                  }))}
                  styles={{
                    menu: (provided) => ({
                      ...provided,
                      zIndex: 1111,
                      // height: "46px",
                    }),
                  }}
                  className="base-line"
                  // value={
                  //   selectedValue
                  //     ? {
                  //         value: selectedValue._id.$oid,
                  //         label: selectedValue.text,
                  //       }
                  //     : {
                  //         value: "66291756f5181c284d0dbbf0",
                  //         label: "Kolkata",
                  //       }
                  // }
                  value={
                    selectedValue
                      ? {
                          value: selectedValue._id.$oid,
                          label: selectedValue.text,
                        }
                      : {
                          value: "",
                          label: "",
                        }
                  }
                  onChange={hanldleTimezoneChange}
                  // isDisabled={true}
                />

                {/* <select
                id="timezone"
                name="timezone"
                value={formData.timezone}
                onChange={handleInputChange}
                required
              >
                <option value="">Select Timezone</option>
                <option value="Asia/Kolkata">Asia/Kolkata</option>
                <option value="America/New_York">America/New York</option>
                <option value="Europe/London">Europe/London</option>
              </select> */}
              </div>
              <div className="form-group">
                <label htmlFor="education">
                  Educational Qualification<span className="red">*</span>
                </label>
                <select
                  id="education"
                  name="education"
                  value={formData.education}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">Select Educational Qualification</option>
                  <option value="High School">High School</option>
                  <option value="Diploma">Diploma</option>
                  <option value="Bachelors">Bachelors</option>
                  <option value="Masters">Masters</option>
                  <option value="PhD">PhD</option>
                </select>
              </div>
            </div>
          )}

          {/* Step 2: Skills and Interests */}
          {step === 2 && (
            <>
              <div className="form-grid multi-form-grid">
                <div className="form-group">
                  <label htmlFor="sme">
                    Skill Category <br />
                    <br />
                  </label>
                  <Multiselect
                    options={categories.filter(
                      (category) => category?._id !== "680c89f84f3447f6da04284f"
                    )}
                    hidePlaceholder={true}
                    closeOnSelect={false}
                    onSelect={(selectedList) =>
                      setFormData({
                        ...formData,
                        skillsCategory: selectedList.map((item) => item._id),
                      })
                    }
                    onRemove={(selectedList) =>
                      setFormData({
                        ...formData,
                        skillsCategory: selectedList.map((item) => item._id),
                      })
                    }
                    selectedValues={categories.filter((category) =>
                      formData.skillsCategory.includes(category._id)
                    )}
                    displayValue="name"
                    className="multi-profile-wrapper"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="expertise">
                    Please fill SME if you plan to offer upskilling services
                  </label>

                  <Multiselect
                    options={expertise}
                    hidePlaceholder={true}
                    closeOnSelect={false}
                    onSelect={(selectedList) =>
                      setFormData({
                        ...formData,
                        experties: selectedList.map((item) => ({
                          value: item,
                        })),
                      })
                    }
                    onRemove={(selectedList) =>
                      setFormData({
                        ...formData,
                        experties: selectedList.map((item) => ({
                          value: item,
                        })),
                      })
                    }
                    selectedValues={formData.experties.map(
                      (item) => item.value
                    )}
                    isObject={false}
                    onSearch={(expertise) => {
                      setExpertiseValue(expertise);
                    }}
                    className="multi-select-wrapper"
                  />
                </div>
              </div>
              <div className="form-grid multi-form-grid">
                <div className="form-group">
                  <label htmlFor="interest">Interest</label>

                  <Multiselect
                    options={interest}
                    hidePlaceholder={true}
                    closeOnSelect={false}
                    onSelect={(selectedList) =>
                      setFormData({
                        ...formData,
                        interest: selectedList.map((item) => ({ value: item })),
                      })
                    }
                    onRemove={(selectedList) =>
                      setFormData({
                        ...formData,
                        interest: selectedList.map((item) => ({ value: item })),
                      })
                    }
                    selectedValues={formData.interest.map((item) => item.value)}
                    isObject={false}
                    onSearch={(interest) => {
                      setInterestValue(interest);
                    }}
                    className="multi-select-wrapper"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="skills">Skills</label>
                  <Multiselect
                    options={skills}
                    hidePlaceholder={true}
                    closeOnSelect={false}
                    onSelect={(selectedList) =>
                      setFormData({
                        ...formData,
                        skills: selectedList.map((item) => ({ value: item })),
                      })
                    }
                    onRemove={(selectedList) =>
                      setFormData({
                        ...formData,
                        skills: selectedList.map((item) => ({ value: item })),
                      })
                    }
                    selectedValues={formData.skills.map((item) => item.value)}
                    isObject={false}
                    onSearch={(skill) => {
                      setSkillValue(skill);
                    }}
                    className="multi-select-wrapper"
                  />
                </div>
              </div>
            </>
          )}

          {/* Step 3: Service Offerings just display no process here */}
          {step === 3 && (
            <>
              {/* Service Offerings */}
              <div className="form-group">
                <label htmlFor="services-offered" className="toggle-label">
                  Services Offered
                  <span className="service-tooltip">
                    ℹ️
                    <span className="tooltiptext">
                      Empower your mentoring journey with flexible service
                      options tailored to your needs. Choose from single
                      sessions for quick insights, weekly engagements for
                      consistent progress, or monthly packages for comprehensive
                      support. Customize your experience and make the most of
                      your mentorship with our versatile service offerings.
                    </span>
                  </span>
                </label>
                <div className="toggle-container">
                  <input
                    type="checkbox"
                    id="services-offered"
                    className="toggle-checkbox"
                    checked={servicesOffered}
                    onChange={() => setServicesOffered((prev) => !prev)}
                  />
                  <label className="toggle" htmlFor="services-offered"></label>
                </div>
              </div>

              {servicesOffered && (
                <>
                  <div className="form-group">
                    <label
                      htmlFor="upskilling-services"
                      className="toggle-label"
                    >
                      Upskilling Services
                    </label>
                    <div className="toggle-container">
                      <input
                        type="checkbox"
                        id="upskilling-services"
                        className="toggle-checkbox"
                        checked={upskillingServices}
                        onChange={() => setUpskillingServices((prev) => !prev)}
                      />
                      <label
                        className="toggle"
                        htmlFor="upskilling-services"
                      ></label>
                    </div>
                  </div>

                  {upskillingServices && (
                    <div className="services-section">
                      <h3>Add Services</h3>

                      {/* Single Session */}
                      <div className="service-item">
                        <label className="toggle-label">
                          Single Session
                          <span className="service-tooltip">
                            ℹ️
                            <span className="tooltiptext">
                              Comprehensive support and mentorship spread out
                              over a month.
                            </span>
                          </span>
                        </label>
                        <button className="edit-icon" disabled>
                          ✏️
                        </button>
                        <div
                          className="toggle-container"
                          style={{
                            marginLeft: "10px",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <input
                            type="checkbox"
                            id="single-session"
                            className="toggle-checkbox"
                            style={{ display: "none" }}
                            disabled // Disable the checkbox
                          />
                          <label
                            className="toggle"
                            htmlFor="single-session"
                          ></label>
                        </div>
                      </div>

                      {/* Repeat for Weekly and Monthly Sessions */}
                      <div className="service-item">
                        <label className="toggle-label">
                          Weekly sessions
                          <span className="service-tooltip">
                            ℹ️
                            <span className="tooltiptext">
                              Comprehensive support and mentorship spread out
                              over a month.
                            </span>
                          </span>
                        </label>
                        <button className="edit-icon" disabled>
                          ✏️
                        </button>
                        <div
                          className="toggle-container"
                          style={{
                            marginLeft: "10px",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <input
                            type="checkbox"
                            id="weekly-session"
                            className="toggle-checkbox"
                            style={{ display: "none" }} // Hide the checkbox
                            disabled // Disable the checkbox
                          />
                          <label
                            className="toggle"
                            htmlFor="weekly-session"
                          ></label>
                        </div>
                      </div>

                      {/* Monthly Sessions */}
                      <div className="service-item">
                        <label className="toggle-label">
                          Monthly sessions
                          <span className="service-tooltip">
                            ℹ️
                            <span className="tooltiptext">
                              Comprehensive support and mentorship spread out
                              over a month.
                            </span>
                          </span>
                        </label>
                        <button className="edit-icon" disabled>
                          ✏️
                        </button>
                        <div
                          className="toggle-container"
                          style={{
                            marginLeft: "10px",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <input
                            type="checkbox"
                            id="monthly-session"
                            className="toggle-checkbox"
                            style={{ display: "none" }}
                            disabled
                          />
                          <label
                            className="toggle"
                            htmlFor="monthly-session"
                          ></label>
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="form-group">
                    <label
                      htmlFor="business-consulting"
                      className="toggle-label"
                    >
                      Business Consulting Service
                    </label>
                    <div className="toggle-container">
                      <input
                        type="checkbox"
                        id="business-consulting"
                        className="toggle-checkbox"
                        checked={businessConsulting}
                        onChange={() => setBusinessConsulting((prev) => !prev)}
                      />
                      <label
                        className="toggle"
                        htmlFor="business-consulting"
                      ></label>
                    </div>
                  </div>

                  {businessConsulting && (
                    <div className="form-group">
                      <label htmlFor="consulting-rate" className="toggle-label">
                        Charges per hour
                      </label>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <span
                          style={{ marginRight: "8px", fontSize: "1.2rem" }}
                        >
                          ₹
                        </span>
                        <input
                          type="text"
                          id="consulting-rate"
                          name="consulting-rate"
                          placeholder="1500"
                          style={{
                            padding: "8px",
                            borderRadius: "5px",
                            border: "1px solid #ddd",
                            width: "120px",
                          }}
                          disabled
                        />
                      </div>
                    </div>
                  )}
                </>
              )}
            </>
          )}

          {step === 4 && (
            <div className="video-apps-container">
              <div className="video-apps-list">
                {/* Google Meet */}
                <div className="video-app-item">
                  <div className="video-app-icon">
                    <img
                      src={googleMeet}
                      alt="Google Meet"
                      width="40"
                      height="40"
                    />{" "}
                    {/* Google Meet Icon */}
                  </div>
                  <div className="video-app-details">
                    <p className="video-app-title">Google Meet</p>
                    {isAuthenticated && (
                      <div className="d-flex mb-2 justify-content-start">
                        <div className="mr-2">
                          <img
                            src={googleData?.google_pic_url}
                            alt="google-pic"
                            className="google-img-profile"
                          />
                        </div>
                        <div className="w-90 pad-r-30">
                          <p className="mb-0">{googleData?.google_name}</p>
                          <p className="mb-0">{googleData?.google_gmail}</p>
                        </div>
                      </div>
                    )}
                  </div>
                  {!isAuthenticated && (
                    <div className="video-app-action">
                      <button
                        className="connect-button"
                        onClick={(e) => {
                          e.preventDefault();
                          handleLinkAccount();
                        }}
                      >
                        Connect
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

          {step === 5 && (
            <div className="step-5-container">
              <div className="progress-bar-container">
                <div
                  className={`progress-bar-segment ${
                    step >= 1 ? "filled" : ""
                  }`}
                ></div>
                <div
                  className={`progress-bar-segment ${
                    step >= 2 ? "filled" : ""
                  }`}
                ></div>
                <div
                  className={`progress-bar-segment ${
                    step >= 3 ? "filled" : ""
                  }`}
                ></div>
                <div
                  className={`progress-bar-segment ${
                    step >= 4 ? "filled" : ""
                  }`}
                ></div>
                <div
                  className={`progress-bar-segment ${
                    step >= 5 ? "filled" : ""
                  }`}
                ></div>
              </div>

              <div className="profile-settings">
                {/* Profile Picture and Change Button */}
                <div className="profile-picture-section">
                  <img
                    src={profilePictureUrl || undrawProfile}
                    className="profile-picture"
                    alt="Profile"
                  />
                  <button
                    className="change-photo-btn"
                    onClick={() => fileInputRef.current.click()} // Trigger the hidden file input when clicked
                    disabled={imageLoading}
                  >
                    {imageLoading ? "Loading" : "Change Photo"}
                  </button>
                  <input
                    type="file"
                    ref={fileInputRef}
                    style={{ display: "none" }} // Hide the file input
                    accept="image/*" // Only accept image files
                    onChange={handleProfilePictureChange}
                  />
                </div>

                {/* User Info Section */}
                <div className="left-column">
                  <div className="form-group">
                    <label htmlFor="Name" className="text-left">
                      Full Name <span className="red">*</span>
                    </label>
                    <input
                      type="text"
                      id="Name"
                      name="Name"
                      value={formData.Name} // Value from step 1
                      readOnly // Make it non-editable
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="headline" className="text-left">
                      Headline<span className="red">*</span>
                    </label>
                    <input
                      type="text"
                      id="headline"
                      name="headline"
                      value={formData.headline} // Value from step 1
                      readOnly // Make it non-editable
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="about" className="text-left">
                      About<span className="red">*</span>
                    </label>
                    <textarea
                      id="about"
                      name="about"
                      placeholder="A few sentences about yourself. This will appear on your personal URL page."
                      value={about}
                      onChange={(e) => setAbout(e.target.value)}
                      rows={5}
                    ></textarea>
                  </div>
                </div>
              </div>

              <div className="navigation-buttons">
                <button
                  type="submit"
                  className={`next-step-btn ${
                    isNextStepEnabled ? "" : "disabled"
                  }`}
                  disabled={!isNextStepEnabled}
                >
                  {step === 5 ? "Finish →" : "Next Step →"}
                </button>
              </div>
            </div>
          )}

          {step === 5 ? null : (
            <div className="navigation-buttons">
              <button
                type="submit"
                className={`next-step-btn ${
                  isNextStepEnabled ? "" : "disabled"
                }`}
                disabled={!isNextStepEnabled}
              >
                Next Step →
              </button>
            </div>
          )}
        </form>
      </div>

      {step > 1 && step < 5 && (
        <div className="skip-button-container">
          <button className="skip-btn" onClick={() => setStep(step + 1)}>
            Setup later
          </button>
        </div>
      )}
    </div>
  );
};

export default ProfileSetup;
